import type { GlobalSearchHit } from "../types";

// Rute per trefftype. Prospekter identifiseres med org_nr; Prospekter-siden
// leser ?q= og forhåndsfyller søket sitt. Notater har ingen egen side –
// id-en er «company:<id>»/«contact:<id>»/«deal:<id>» og treffet lander
// på kortet.
const notePath = (id: string): string => {
  const [kind, targetId] = id.split(":");
  if (kind === "company") return `/companies/${targetId}/show`;
  if (kind === "deal") return `/deals/${targetId}/show`;
  return `/contacts/${targetId}/show`;
};

export const entityPath = (
  type: GlobalSearchHit["entity_type"],
  id: string,
): string =>
  ({
    company: `/companies/${id}/show`,
    contact: `/contacts/${id}/show`,
    project: `/projects/${id}/show`,
    work_item: `/work_items/${id}`,
    deal: `/deals/${id}/show`,
    note: notePath(id),
    email: `/email/sent/${id}`,
    prospect: `/prospects?q=${encodeURIComponent(id)}`,
  })[type];

// Lenker i svar fra «Spør Claude» har formen mimin://{type}/{id}, der type er
// det verktøyene i ask_claude kaller posten. Ukjent type eller ugyldig id gir
// null, og lenken vises da som ren tekst.
const MIMIN_TYPES: Record<string, GlobalSearchHit["entity_type"]> = {
  customer: "company",
  company: "company",
  contact: "contact",
  project: "project",
  task: "work_item",
  deal: "deal",
  email: "email",
  prospect: "prospect",
};

const MIMIN_HREF = /^mimin:\/\/([a-z_]+)\/([\w-]+)\/?$/;

// Nøkkelen («customer:42») lenken svarer til i verktøyresultatene fra
// ask_claude (result.ts, refKey). Null for alt som ikke er en mimin-lenke.
export const miminRef = (href: string): string | null => {
  const match = MIMIN_HREF.exec(href.trim());
  if (!match || !MIMIN_TYPES[match[1]]) return null;
  return `${match[1] === "company" ? "customer" : match[1]}:${match[2]}`;
};

export const miminPath = (href: string): string | null => {
  const match = MIMIN_HREF.exec(href.trim());
  if (!match) return null;
  const type = MIMIN_TYPES[match[1]];
  return type ? entityPath(type, match[2]) : null;
};
